module.exports = __webpack_public_path__ + "media/images/banner/unipolsai_desktop-f9d94bd97091c38857b1c321efadd318.jpg";